export default {
  path: '/change-payment',
  meta: {
    title: '收款方式',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/change-payment`),
}



// WEBPACK FOOTER //
// ./src/views/changePayment/router.js